import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { Elevation } from 'rmwc/Elevation';
import { TextField} from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import GlobalSetting from './GlobalSetting'

class AdminChangePWADashboardBanner extends Component {

  constructor(props){
    super(props);
    this.state={
      dashboardDetails: [],
      errorMsg: '',
    }
  }

  componentDidMount() {
    let url = `/admin/dashboard/banner/details`
    return api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      console.log(result)
      if(result.status === 'success'){
        this.setState({
          dashboardDetails: result.data,
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  render() {

    //let targetLinkValidString = '/pwa/app'
    let imageLinkValidation = 'http'
    return(
      <div>
        <Card style={{padding: '25px'}}>
          <Typography use="headline5">Change PWA Dashboard Banner and it's target link.</Typography>
          <br/>
          {this.state.dashboardDetails.map(function (banner) {
            
            if(banner.name.includes('PWA_DASHBOARD_IMAGE_')){
              return <Elevation z='4'><GlobalSetting setting={banner} validationString={imageLinkValidation} /></Elevation>
            }
            else if(banner.name.includes('PWA_DASHBOARD_TARGET_')){
              return <Elevation z='4'><GlobalSetting setting={banner} validationString={imageLinkValidation} /></Elevation>
            }

            })}
          <StatusMessage error_msg = {this.state.errorMsg} />
        </Card>
      </div>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminChangePWADashboardBanner);


// WEBPACK FOOTER //
// ./src/views/admin/AdminChangePWADashboardBanner.jsx